import { FactionBadge } from "./FactionBadge";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const factionDescriptions = [
  {
    name: "APEX-COURIER / AETHER-GRID",
    text: "The elite autonomous logistics fleet. Operators protect high-value cargo, maintain courier systems, and keep hostile-sector delivery routes open.",
  },
  {
    name: "BLACK-OPS NET",
    text: "Covert cyber operators specializing in surveillance, signal interception, infiltration, and precision network warfare.",
  },
  {
    name: "SCRAPPER",
    text: "Independent engineers and wasteland salvagers who build powerful tools, weapons, and defenses from reclaimed corporate technology.",
  },
  {
    name: "SAFE ZONE ARMY",
    text: "The organized defense force protecting settlements, civilian routes, supply lines, and fortified safe-zone infrastructure.",
  },
  {
    name: "WASTELAND RUNNER",
    text: "High-risk ground couriers and survivors who move critical cargo through hostile sectors using speed, scavenged gear, and route knowledge.",
  },
  {
    name: "UNAFFILIATED",
    text: "Independent operators with no declared allegiance. They choose their own contracts, routes, alliances, and rules of engagement.",
  },
];

export function FactionGuide({ activeFaction }) {
  return (
    <section className="faction-guide" data-testid="faction-guide-section">
      <SectionHeading
        eyebrow="FACTION GUIDE"
        title="Choose your allegiance before transmission."
        text="Each faction offers a different role inside the wasteland network. Your selection is included with the enlistment signal."
      />
      <div className="faction-guide-grid">
        {factionDescriptions.map((faction, index) => (
          <Reveal
            className={`faction-guide-card ${activeFaction === faction.name ? "is-active" : ""}`}
            delay={index * 0.05}
            key={faction.name}
          >
            <span>{String(index + 1).padStart(2, "0")}</span>
            <FactionBadge faction={faction.name} active={activeFaction === faction.name} />
            <h3>{faction.name}</h3>
            <p>{faction.text}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
